import {Component, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AuthenticationService} from '../../../services/authentication/authentication.service';
import {djangourl} from '../../../../assets/urls';
import {ActivatedRoute, Router} from '@angular/router';
import * as moment from 'jalali-moment';




@Component({
  selector: 'app-order-detail',
  templateUrl: './order-detail.component.html',
  styleUrls: ['./order-detail.component.scss']
})
export class OrderDetailComponent implements OnInit {

  orderUrl = djangourl + 'api/orders/';
  offUrl = djangourl + 'api/offcodes/';
  id: any;
  order: any = {
    buyer: '',
    code: '',
    id: '',
    num: 0,
    order_time: '2000-01-01T00:00:00.744942Z',
    price: 0,
    product: '0',
    product_name: '',
    ref: '',
    status: '',
    statusCode: -1,
    user_name: '',
    user_phone: ''
  };
  off: any = {
    amount: 0

  };
  user: any = {
    username: '',
    email: '',
    role: '',
    first_name: '',
    last_name: '',
    phone_number: '',
    address: '',
    postal_code: ''
  };
  ready = false;

  constructor(private route: ActivatedRoute, private http: HttpClient, private authenticationService: AuthenticationService, private router: Router) {
  }

  ngOnInit() {
    moment.locale('fa', {useGregorianParser: true});
    this.route
      .params
      .subscribe(v => {
        this.id = v.id;
      });
    this.http.get(this.orderUrl + this.id).subscribe(data => {
      this.order = data;
      this.ready = true;


    });

  }

  // generatePdf(action = 'open') {
  //   const documentDefinition = this.getDocumentDefinition();
  //   switch (action) {
  //     case 'open':
  //       pdfMake.createPdf(documentDefinition).open();
  //       break;
  //     case 'print':
  //       pdfMake.createPdf(documentDefinition).print();
  //       break;
  //     case 'download':
  //       pdfMake.createPdf(documentDefinition).download();
  //       break;
  //     default:
  //       pdfMake.createPdf(documentDefinition).open();
  //       break;
  //   }
  //
  // }

  // getDocumentDefinition() {
  //   return {
  //     content: [
  //       {
  //         text: this.rev('فاکتور خرید'),
  //         bold: true,
  //         font: 'Samim',
  //         fontSize: 20,
  //         alignment: 'center',
  //         margin: [0, 0, 0, 20]
  //       },
  //       {
  //         margin: [0, 5, 0, 0],
  //         columns: [
  //           [{
  //             text: this.rev('مشخصات خریدار'),
  //             font: 'Samim',
  //             style: 'header'
  //
  //           }, {
  //             text: this.rev( this.order.user_name),
  //             font: 'Samim',
  //             alignment: 'right',
  //
  //           }, {
  //             text: this.rev('آدرس: ' + this.order.user_address),
  //             font: 'Samim',
  //             alignment: 'right',
  //             fontSize: 8,
  //             margin: [0, 5, 0, 0],
  //
  //           }, {
  //             text: this.rev('شماره تماس: ' + this.order.user_phone),
  //             font: 'Samim',
  //             alignment: 'right',
  //             fontSize: 8
  //
  //           },
  //
  //           ]
  //         ]
  //       },
  //       {
  //         text: this.rev('جزئیات سفارش'),
  //         font: 'Samim',
  //         style: 'header',
  //         margin: [0, 30, 0, 0],
  //
  //
  //       },
  //       {
  //
  //         table: {
  //           widths: ['*', '*', '*', 30, 200,],
  //           body: [
  //             [{
  //               text: this.rev('مبلغ کل'),
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: this.rev('تخفیف'),
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: this.rev('مبلغ واحد'),
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: this.rev('تعداد'),
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: this.rev('شرح'),
  //               font: 'Samim',
  //               alignment: 'center'
  //             },],
  //
  //             [{
  //               text: this.numberWithCommas(this.order.price  ),
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: this.numberWithCommas( this.order.dis_amount),
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: this.numberWithCommas(this.order.product_price),
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: 1,
  //               font: 'Samim',
  //               alignment: 'center'
  //             }, {
  //               text: this.rev(this.order.product_name),
  //               font: 'Samim',
  //               alignment: 'center'
  //             },]
  //           ]
  //         }
  //
  //       }, {
  //         text: this.rev('مبالغ به تومان می باشد'),
  //         font: 'Samim',
  //         alignment: 'left',
  //         fontSize: 10
  //       },
  //       {
  //         margin: [0, 10, 0, 0],
  //         columns: [
  //           [
  //             {
  //               text: this.rev('شماره سفارش: ' + this.order.num),
  //               font: 'Samim',
  //               alignment: 'right',
  //
  //
  //             }, {
  //             text: this.rev('تاریخ ثبت سفارش: ' + this.convertDate2(this.order.order_time)),
  //             font: 'Samim',
  //             alignment: 'right',
  //
  //           }, {
  //             text: this.rev('وضعیت سفارش:  ' + this.getStatus(this.order.statusCode)),
  //             font: 'Samim',
  //             alignment: 'right',
  //
  //           }
  //
  //           ]
  //         ]
  //       },
  //
  //
  //       {
  //         text: this.rev('آدرس: تهران ، خیابان حبیب‌الهی، خیابان شهید قاسمی، خیابان گلستان، بن‌بست گل، پلاک چهارم، طبقه‌ی همکف، واحد دوم'),
  //         font: 'Samim',
  //         alignment: 'center',
  //         margin: [0, 80, 0, 0],
  //         fontSize: 8
  //
  //       },
  //
  //       {
  //         text: this.rev('شماره تماس:   021-66051855'),
  //         font: 'Samim',
  //         alignment: 'center',
  //         fontSize: 8
  //
  //       },
  //
  //       {
  //         text: this.rev('بهترین خودت باش'),
  //         font: 'Samim',
  //         alignment: 'center',
  //         margin: [0, 5, 0, 0],
  //         fontSize: 10
  //       },
  //       {
  //         text: this.rev('مای اسمارت ژن'),
  //         font: 'Samim',
  //         alignment: 'center',
  //         bold: true
  //       },
  //       ,
  //       {
  //         text: this.rev('برای مشاهده نسخه الکترونیکی فاکتور بارکد زیر را اسکن کنید'),
  //         font: 'Samim',
  //         alignment: 'left',
  //         fontSize: 7,
  //       },
  //       {
  //         columns: [
  //           {qr: 'http://mysmartgene.com/#/payment/order-detail;id=' + this.id},
  //
  //         ]
  //
  //
  //       }
  //     ],
  //     info: {
  //       title: 'فاکتور خرید',
  //       author: 'مای اسمارت ژن',
  //       subject: 'فاکتتور خرید از مای اسمارت ژن',
  //       keywords: 'مای اسمارت ژن',
  //     },
  //     styles: {
  //       header: {
  //         fontSize: 18,
  //         bold: true,
  //         alignment: 'right',
  //         margin: [0, 20, 0, 10],
  //
  //       },
  //       name: {
  //         fontSize: 16,
  //         alignment: 'right',
  //         // bold: true
  //       },
  //       jobTitle: {
  //         fontSize: 14,
  //         alignment: 'right',
  //         // bold: true,
  //         // italics: true
  //       },
  //       sign: {
  //         margin: [0, 50, 0, 10],
  //         alignment: 'right',
  //         //  italics: true
  //       },
  //       tableHeader: {
  //         alignment: 'right',
  //         // bold: true,
  //       }
  //     }
  //   };
  // }

  //
  // rev(text: string) {
  //   return (' ' + text).split(' ').reverse().join(' ');
  // }

  numberWithCommas(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  convertDate(date: any) {
    return moment(date).format('dddd D MMMM YYYY   ساعت    HH:mm');
  }

  convertDate2(date: any) {
    return moment(date).format('YYYY/MM/DD');
  }

  getColor(status) {
    switch (status) {
      case 'PENDING':
        return {'color': 'blue'};
      case 'CANCELED':
        return {'color': 'red'};
      case 'COMPLETED':
        return {'color': 'green'};
      case 'FAILED':
        return {'color': 'red'};
      default:
        return {'color': 'black'};

    }
  }

  getStatus(statusCode) {
    statusCode = statusCode.toString();
    switch (statusCode) {
      case '0':
        return 'پرداخت توسط کاربر لغو شده است';

      case '1':
        return 'اطلاعات ارسال شده ناقص است';

      case '2':
        return 'IP یا مرچنت پذیرنده معتبر نیست';

      case '3':
        return 'با توجه به محدودیت های شاپرک امکان پرداخت با رقم درخواست شده میسر نیست';

      case '4':
        return 'سطح تایید پذیرنده پایین تر از سطح نقره ای است';

      case '8':
        return 'کد تخفیف وارد شده در حال استفاده می باشد';

      case '9':
        return 'کد تخفیف وارد شده استفاده شده است';

      case '11':
        return 'درخواست مورد نظر یافت نشد';

      case '12':
        return 'امکان ویرایش درخواست میسر نمی باشد';

      case '21':
        return 'سطح تایید پذیرنده پایین تر از سطح نقره ای است';

      case '22':
        return 'تراکنش ناموفق می باشد';

      case '33':
        return 'رقم تراکنش با رقم پرداخت شده مطابقت ندارد';

      case '34':
        return 'سقف تقسيم تراكنش از لحاظ تعداد يا رقم عبور نموده است';

      case '40':
        return 'اجازه دسترسي به متد مربوطه وجود ندارد';

      case '41':
        return 'اطلاعات ارسال شده مربوط به AdditionalData غيرمعتبر ميباشد';

      case '42':
        return 'مدت زمان معتبر طول عمر شناسه پرداخت بايد بين 30 دقيه تا 45 روز مي باشدد';

      case '54':
        return 'درخواست مورد نظر آرشيو شده است';

      case '100':
        return 'عمليات با موفقيت انجام گرديده است';

      case '101':
        return 'عمليات پرداخت موفق بوده و قبلا PaymentVerification تراكنش انجام شده است';

      case '-1':
        return 'نامشخص';


    }
  }


}
